"use client";
import { Image } from "@chakra-ui/next-js";
import { StaticImageData } from "next/image";

const ClientImage = ({ src, alt }: { src: StaticImageData; alt: string }) => {
  return <Image src={src} alt={alt} />;
};

export default ClientImage;
